import React from 'react';
import CardContainer from "./CardContainer";
import PropTypes from 'prop-types';
import { useNavigate, useParams } from "react-router-dom";

import {Flex} from "reflexbox";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import SkeletonImage from "../common/SkeletonImage";
import Box from "@mui/material/Box";
import {ToMap} from "../helpers/routes";
import {courses, fetchCourseContent, getTotalQsByLocation} from "../courseContent/courseObjects";


const LocationQuestion = (props) => {
  let navigate = useNavigate();
  const {course} = useParams();
  const currentCourseName = course || null;
  const totalQsByLocation = getTotalQsByLocation(fetchCourseContent(currentCourseName));
  const locationOrder = totalQsByLocation ? Object.keys(totalQsByLocation) : ['error'];

  if (!currentCourseName || !courses[currentCourseName]) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Typography variant="h6" color="error">
          Course not found: {currentCourseName}
        </Typography>
        <Typography>
          Please select a valid course from the course selector.
        </Typography>
      </div>
    );
  }

  const mapPreviewSrc = courses[currentCourseName].mapPreview || null;

  const handleContinue = () => {
    navigate(props.nextURL)
  };

  const actionsComponent = (
    <Flex style={{justifyContent: 'center'}}>
        <Button variant={'contained'} color={'primary'} onClick={handleContinue}>I'm here</Button>
    </Flex>
  );
  const ordinalNumber = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eigth'];
  const clueNumberText = 'Clue for Your ' + (ordinalNumber[locationOrder.indexOf(props?.location.name)] || 'Next') + ' Destination';

  const steps = [];
  locationOrder.forEach((val, key) => {
    steps.push(<Step key={key}><StepLabel/></Step>);
  });

  const locationProgress = (<Flex style={{flexDirection: 'column', paddingBottom: '16px'}}>
      <Typography variant={'h6'} style={{padding: '16px 16px 0 16px'}}> {clueNumberText} </Typography>
      <Stepper activeStep={locationOrder.indexOf(props?.location.name)}
               style={{padding: '16px 0 0 0'}}
               orientation={'horizontal'} alternativeLabel>
        {steps}
      </Stepper>
    </Flex>
  );

  const viewMap = mapPreviewSrc && <Flex onClick={() => navigate(ToMap(currentCourseName))}
                    style={{marginBottom: '16px', flexDirection: 'column', alignItems: 'center'}}>
    <SkeletonImage blueOverlay noCheck skeletonHeight={'116px'} id={'map'}
                   src={mapPreviewSrc}
                   style={{marginBottom: '16px'}}
                   alt={null}/>
    <Box style={{height: 0}} >
      <Button variant={'contained'} style={{position: 'relative', bottom: '76px', zIndex: 3}}>View
        Map</Button>
    </Box>
  </Flex>;

  return (
    <>
      <CardContainer
        alternateHeader={locationProgress}
        cardContent1={props.content1}
        cardMediaImg={props.image1 || null}
        cardContent2={props.content2 || null}
        cardMediaImg2={props.image2 || null}
        captionContent={props.captionContent}
        map={viewMap}
        actionsComponent={actionsComponent}
      />
    </>
  )
};

LocationQuestion.propTypes = {
  location: PropTypes.object,
  nextURL: PropTypes.string.isRequired,
  image1: PropTypes.string,
  content: PropTypes.any.isRequired,
  image2: PropTypes.string,
  content2: PropTypes.any,
  captionContent: PropTypes.any,
};

export default LocationQuestion;